import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateFaqCategoryRequest extends BaseUpdateRequest {
    name = '';  
}